// /**
//  * 二手车列表
//  * http://mockjs.com/
// url： https://testzsqy.cheanjia.com/?mock=1/// #/sms/4
//  */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 线索车商列表+get
// 接口地址 /api/v1/used_car/dealer_users
Mock.mock(/used_car\/dealer_users$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'car_dealers|3': [{
      'dealer_organization_name': '车商机构名称',
      'dealer_organization_id': 1, // # 机构id
      'dealer_user_id|+1': 1, // # 车商id
      'dealer_user_status': 1, // # 车商状态
      'dealer_user_name': '车商名共分为分隔符',
      'is_qualified': true // # 是否可选
    }, {
      'dealer_organization_name': '购房人灌灌灌灌',
      'dealer_organization_id': 1, // # 机构id
      'dealer_user_id': 1, // # 车商id
      'dealer_user_status': 1, // # 车商状态
      'dealer_user_name': '车商名bb',
      'is_qualified': false // # 是否可选
    }]
  }
})
// 拍卖车商列表+get
// 接口地址 /api/v1/auctions/dealer_users
Mock.mock(/auctions\/dealer_users$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'car_dealers|5': [{
      'dealer_organization_name': '哥哥嘎嘎嘎',
      'dealer_organization_id': 1, // # 机构id
      'dealer_user_id': 1, // # 车商id
      'dealer_user_status': 1, // # 车商状态
      'dealer_user_name': '车商名',
      'is_qualified': true // # 是否可选
    }, {
      'dealer_organization_name': '车商机构名称',
      'dealer_organization_id': 1, // # 机构id
      'dealer_user_id': 1, // # 车商id
      'dealer_user_status': 1, // # 车商状态
      'dealer_user_name': '车商名',
      'is_qualified': false // # 是否可选
    }]
  }
})
